<template>
  <div class="form-block" :class="{'form-block--warning': validationError}">
    <div class="form-block-inner">
      <label>{{field.name}}</label>
      <input type="text" v-model="value" :placeholder="field.placeholder" @keyup="changed" />
    </div>
    <div class="form-error" v-if="validationError">
      <i class="icon-error"></i> {{field.name}} is required
    </div>
  </div>
</template>

<script>
export default {
  props: ['field', 'validationError'],
  name: "TextField",
  data() {
    return {
      value: ''
    }
  },
  methods: {
    changed() {
      this.$emit('changed', {
        idContentField: this.field.idContentField,
        type: this.field.fieldType,
        files:[],
        multiple: this.field.isMultiline,
        "value": this.value,
        "values":[]
        }
      );
    }
  }
}
</script>

<style scoped>

</style>
